import { BookingHistoryResponse } from "../../types/bookingHistory";
import { getEnvironmentProps } from "../../utils/environment";
import { dmnIdentity } from "../../utils/dmnIdentity";
import { errorHandler, apiFetchNotOkHandler } from "../errorHandler";

export const fetchBookingHistory = async (
  bookingId?: string
): Promise<BookingHistoryResponse | undefined> => {
  if (!bookingId) return undefined;

  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  return await fetch(
    `${environmentVars?.CORE_API_BASE_URL}/bookings/${bookingId}/history`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )
    .then(async (response) => {
      if (response.ok) {
        const data = await response.json();
        if (data?.payload?.history && Array.isArray(data.payload.history)) {
          return data.payload as BookingHistoryResponse;
        }
        return undefined;
      }

      apiFetchNotOkHandler(
        response,
        `Error fetching booking history for booking ${bookingId}`
      );
      return undefined;
    })
    .catch((error) => {
      errorHandler(
        error,
        `Error fetching booking history for booking ${bookingId}`
      );
      return undefined;
    });
};
